import styled from "styled-components";
import { FaTwitter, FaFacebookSquare, FaInstagram } from "react-icons/fa";
import tw from "twin.macro";

export const Twitter = styled(FaTwitter)`
  ${tw`flex-auto mb-2`}
`;

export const Facebook = styled(FaFacebookSquare)`
  ${tw`flex-auto mb-2`}
`;

export const Instagram = styled(FaInstagram)`
  ${tw`flex-auto mb-2`}
`;